import client from 'posthog-js';

import { isTruthy } from '../bool';

import { SEPARATOR } from '../../constants';

const KEY = process.env.POSTHOG_KEY;
const HOST = process.env.POSTHOG_HOST;

export const posthog = {
  client,
  init() {
    if (!KEY || !HOST) return;

    this.client.init(KEY, { api_host: HOST, autocapture: false, capture_pageview: false });
    this.initialized = true;
  },
  setUser(user) {
    if (!this.initialized) return;

    if (this.identified) {
      this.client.reset();
    }

    if (!user) {
      this.identified = false;
      return;
    }

    const firstName = (user.firstName || '');
    const lastName = user.lastName || '';
    const name = [firstName, lastName].filter(isTruthy).join(SEPARATOR.SPACE);
    this.client.identify(user.userId, { email: user.email, name });
    this.identified = true;
  },
};
